import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faBars, faX } from '@fortawesome/free-solid-svg-icons';
import LOGOBLACK from './images/logo-black-nt.png';
import { MainBtn, SecondaryBtn } from './Styled';
import {
  Navigation,
  LogoCon,
  LinksCon,
  LinkConInner,
  NavLink,
  MenuBtn,
  NavLinkCon,
  Nav,
  CallLink,
  NavPhoneMenu,
} from './Navbar.styled';

const LINKS = [
  { to: '/appudvikling', text: 'Appudvikling' },
  { to: '/webudvikling', text: 'Webudvikling' },
  { to: '/cases', text: 'Cases' },
];

const NavBarDiff = () => {
  const [currentClass, setClass] = useState(false);
  const [phoneOpen, setPhoneOpen] = useState(false);

  const changeClassOnScroll = () => {
    if (window.scrollY >= 25) {
      setClass(true);
    } else {
      setClass(false);
    }
  };

  const openPhoneMenu = () => {
    setPhoneOpen(!phoneOpen);
  }

  window.addEventListener('scroll', changeClassOnScroll);

  return (
    <>
      <Nav className={currentClass ? 'active' : ''}>
        <Navigation>
          <LogoCon>
            <a href="/">
              <img src={LOGOBLACK} alt="Forside" height="55px" />
            </a>
          </LogoCon>
          <LinksCon key="list-con">
            <LinkConInner key="list" className="navlink">
              {LINKS.map(l => (
                <NavLinkCon key={`${l.to}`}>
                  <NavLink to={l.to} key={l.to}>
                    {l.text}
                  </NavLink>
                </NavLinkCon>
              ))}
              <li>
                <Link to="/kontakt">
                  <MainBtn type="button" className="mainbtn">
                    Kontakt os
                  </MainBtn>
                </Link>
              </li>
              <NavLinkCon>
                <NavLink>
                  <CallLink href="tel:004520741066">
                    <FontAwesomeIcon icon={faPhone} /> 20 74 10 66
                  </CallLink>
                </NavLink>
              </NavLinkCon>
            </LinkConInner>
          </LinksCon>
          <MenuBtn icon={faBars} onClick={openPhoneMenu} />
        </Navigation>
      </Nav>
      <NavPhoneMenu className={phoneOpen ? 'active' : ''}>
        <ul>
          <li>
            <FontAwesomeIcon icon={faX} onClick={openPhoneMenu} />
          </li>
          <li>
            <Link to='/appudvikling'>
              Appudvikling
            </Link>
          </li>
          <li>
            <Link to='/webudvikling'>
              Webudvikling
            </Link>
          </li>
          <li>
            <Link to='/cases'>
              Cases
            </Link>
          </li>
          <li>
            <Link to='/kontakt'>
              <SecondaryBtn>
                Kontakt
              </SecondaryBtn>
            </Link>
          </li>
        </ul>
      </NavPhoneMenu>
    </>
  );
};

export default NavBarDiff;
